export enum OtherFacetGroupCode {
  ProductionType = "Productiontype_Other",
  ContractType = "ContractType_Other",
  Gender = "Gender_Other",
  Appearance = "appearance_otherAppearance",
  Disability = "disability_Other",
}

export const facetCategoryCodes = {
  productionType: "Productiontype",
  contractType: "ContractTypes",
  gender: "Gender",
  appearance: "appearance",
  disability: "disability",
  complaintCategory: "Complaintcategories",
  ethnicBackground: "ethnicBackground",
  heritageAndEthnicity: "heritageAndEthnicity",
};

export const facetGroupCode = {
  productionType: {
    frequentlyUsed: "Productiontype_Frequentlyused",
    other: "Productiontype_Other",
  },
  contractType: {
    paidEquity: "ContractTypes_PaidEquity",
    paidOther: "ContractTypes_PaidOther",
    lowPay: "ContractTypes_Lowpay",
  },
  gender: {
    other: "Gender_Other",
  },
  appearance: {
    black: "appearance_black",
    european: "appearance_european",
    asian: "appearance_asian",
    other: "appearance_otherAppearance",
  },
  disability: {
    disability: "disability_disability",
    other: "disability_Other",
  },
  complaintCategory: {
    other: "Complaintcategories_Other",
  },
};

export const anyPlayingAgeRange = { min: 3, max: 99 };

export const anyHeightRange = { min: 0.61, max: 2.44 };

export const JOBS_FEED_SETTINGS_PATHNAME = "/settings/jobs-feed";
